'use client'

import { OutlineButton, Text } from '@macarongfactory/web-ui'

import {
  RANK_TRACK_CODE,
  RANK_VISIBLE_LIMIT,
  useRankImpression,
  useRankTrackingContext,
} from '../_features/rank'

interface IRankMoreCtaProps {
  totalCount: number
  buttonText: string
  onMoreClick: () => void
}

const RankMoreCta = ({
  totalCount,
  buttonText,
  onMoreClick,
}: IRankMoreCtaProps) => {
  const track = useRankTrackingContext()
  const ref = useRankImpression<HTMLDivElement>(() =>
    track.itemShow(RANK_TRACK_CODE.RANK_MORE, 'section', '앱에서 전체보기 유도')
  )

  const hasMore = totalCount > RANK_VISIBLE_LIMIT
  const message = hasMore
    ? `마이클 앱에서 실시간으로\n${totalCount.toLocaleString()}개 차량 랭킹을 볼 수 있어요`
    : '마이클 앱에서 실시간 랭킹을 볼 수 있어요'

  const handleClick = () => {
    track.itemClick(RANK_TRACK_CODE.RANK_MORE, 'button', '앱에서 전체보기 클릭')
    onMoreClick()
  }

  return (
    <div
      ref={ref}
      className='flex flex-col items-center justify-center gap-dimension-x3 px-dimension-x16 py-dimension-x14'
    >
      <Text
        variant='title-1-semibold'
        color='text-foreground-neutral-strong'
        className='block whitespace-pre-line text-center'
      >
        {message}
      </Text>
      <OutlineButton
        text={buttonText}
        variant='brand'
        size='medium'
        clickable={handleClick}
      />
    </div>
  )
}

export default RankMoreCta
